import { render, staticRenderFns } from "./NewsCompile.vue?vue&type=template&id=e24663be&scoped=true"
import script from "./NewsCompile.vue?vue&type=script&lang=js"
export * from "./NewsCompile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24663be",
  null
  
)

export default component.exports